var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import { CheckedState, } from "./utilities/projecttable";
let SectionRow = class SectionRow extends Vue {
    checkChange() { }
    get checked() { return this.checkState === CheckedState.all; }
    get partial() { return this.checkState === CheckedState.partial; }
};
__decorate([
    Prop({ required: true })
], SectionRow.prototype, "checkBox", void 0);
__decorate([
    Prop({ required: true })
], SectionRow.prototype, "checkState", void 0);
__decorate([
    Prop({ required: true })
], SectionRow.prototype, "numberOfColumns", void 0);
__decorate([
    Prop({ required: true })
], SectionRow.prototype, "type", void 0);
__decorate([
    Inject()
], SectionRow.prototype, "i18n", void 0);
__decorate([
    Emit()
], SectionRow.prototype, "checkChange", null);
SectionRow = __decorate([
    Component({
        name: "SectionRow",
    })
], SectionRow);
export default SectionRow;
